// extracted by mini-css-extract-plugin
export default {"textBottomContainer":"style_textBottomContainer__gcaPS","helperText":"style_helperText__Owlw1","limitWarning":"style_limitWarning__8sgqh","counterBox":"style_counterBox__9+Zh1"};